<template>
  <section id="section-service" class="section">
    <div class="flex-column section-content d-flex">
      <div class="section-title-container d-flex section-container">
        <a style="align-self: center">我们的服务</a>
      </div>
      <div v-for="(item, index) in items" :key="index" v-bind:class="css_yimu_item[index%2]">
        <div class="flex-column yimu-item-intro">
          <div class="brand-name" v-bind:style="{textAlign: (index%2===0)?'left':'right'}">{{item.title}}</div>
          <div class="subtitle"><span
            v-for="(txt,idx) in item.intro" :key="'intro-'+idx">{{txt}}</span>
          </div>
        </div>
        <div class="d-block d-lg-none" style="min-width: 20px"></div>
        <div class="d-inline-flex"><img :src="item.icon" align="center" class="item-img"/></div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: "SectionService",
    data() {
      return {
        css_yimu_item: [
          'd-flex flex-row yimu-item',
          'd-flex flex-row-reverse yimu-item'
        ],
        items: [{
          title: "无会头也可建会",
          intro: ["家族会、同学会、同事会，知根知底，", "互相监督，风险共担。"],
          icon: require("../assets/img_ser_nofounder.png")
        }, {
          title: "微信记账，透明公正",
          intro: ["谁参会，谁中标，谁已交费，谁拖欠，", "账目清晰，所有人一目了然。"],
          icon: require("../assets/img_ser_wx.png")
        }, {
          title: "电子借条，合法有效",
          intro: ["中标人打好借条，才能收钱，保护会员", "的合法权益。"],
          icon: require("../assets/img_ser_eiou.png")
        }, {
          title: "平台协助，提醒交费",
          intro: ["谁已交费，平台协助提醒，无需你亲自", "开口，避免尴尬。"],
          icon: require("../assets/img_ser_notify.png")
        }]
      }
    }
  }
</script>
<style scoped>
  @media (min-width: 992px) {
    .item-img {
      min-width: 188px;
      min-height: 188px;
    }

    .section-container {
      margin-top: 52px;
      margin-bottom: 52px;
    }

    .brand-name {
      margin: 0;
    }

    .yimu-item {
      margin-top: 10px;
    }

    .yimu-item-intro {
      max-width: 320px;
    }

    .subtitle {
      text-align: justify;
    }
  }

  @media (max-width: 992px) {
    .item-img {
      min-width: 94px;
      min-height: 94px;
      align-self: center;
      margin: auto;
    }

    .brand-name {
      font-size: 18px;
      margin: 0;
    }

    .subtitle {
      font-size: 14px;
      text-align: justify;
    }

    .yimu-item {
      margin: 40px 40px 0 40px;
      justify-content: space-between;
    }

  }

  .yimu-item-intro {
    align-self: center;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/SectionService.vue